import React, { useState } from "react";
import { Box, Typography, Button, Container, Grid, Card, CardMedia, CardContent } from "@mui/material";
import bannerImg from "../../Assets/Module_mounting_banner.jpg"; // change if needed
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../Api/Axios/axios";
import { endpoints } from "../../Api/EndPoints/endpoints";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import FanImage from "../../Assets/mm-structure-01.jpg"; // update your image


const cardData = [
    {
        id: 1,
        title: "Black Tea ",
        image: FanImage,
        path: "/products/tea-processing-machinery/black-tea"
    },
    {
        id: 2,
        title: "Green Tea",
        image: FanImage,
        path: "/products/ctc/greensteaming-process"
    },

];

const ProcessingCard = () => {

    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [cardDataa, setCardData] = useState([])

    const getData = async () => {
        try {
            const res = await axiosInstance.get(endpoints.ModuleMounting.Introduction);
            const CardRes = await axiosInstance.get(endpoints.TpmCard.InnerCard);
            setCardData(CardRes?.data?.data)
            setData(res?.data?.data)
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getData()
    }, [])


    const BlackhandleClick = () => {
        navigate('/products/tea-processing-machinery/black-tea');
    };

    const GreenhandleClick =()=>{
       navigate('/products/ctc/greensteaming-process'); 
    }



    return (
        <>
            {/* ================= BANNER ================= */}
            <Box
                sx={{
                    width: "100%",
                    height: { xs: "220px", sm: "300px", md: "380px" },
                    backgroundImage: `url(${cardDataa?.image1})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {/* Overlay */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        background: "rgba(0,0,0,0.6)",
                    }}
                />

                {/* Banner Content */}
                <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
                    <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>

                        {/* Title */}
                        <Typography
                            sx={{
                                color: "#fff",
                                fontSize: { xs: "24px", sm: "32px", md: "42px" },
                                fontWeight: 700,
                                fontFamily: "Roboto",
                                mb: 2,
                            }}
                        >
                            {cardDataa?.title1}
                        </Typography>

                        {/* Breadcrumbs */}
                        <Typography sx={{ color: "#fff", fontSize: "14px" }}>
                            <Typography
                                component={Link}
                                to="/home"
                                underline="none"
                                sx={{ color: "#fff", textdecoration: "none", fontSize: "15px", }}
                            >
                                Home
                            </Typography>


                            {" / "}
                            <Typography
                                component={Link}
                                to="/products/tea-processing-machinery/Tmd-Division-machine-structure"
                                underline="none"
                                sx={{ color: "#fff", textdecoration: "none", fontSize: "15px", }}
                            >
                                TMD Machine Structure
                            </Typography>
                            {" / "}
                            <Typography
                                component="span"
                                sx={{ color: "#fff", fontWeight: 500 }}
                            >
                                Tea Processing Machinery
                            </Typography>
                        </Typography>
                    </Box>

                </Container>
            </Box>

            {/* ================= CONTENT ================= */}
            <Container maxWidth="xl">
                <Box
                    sx={{
                        textAlign: "center",
                        py: { xs: 4, sm: 5, md: "60px" },
                        px: { xs: 2, sm: 3 },
                        paddingBottom: "150px!important"
                    }}
                >
                    {/* Title */}


                    {/* Subtitle */}


                    {/* Learn More Button */}
                    <Grid container spacing={3} justifyContent="center"   >
                        {/* Four Responsive Cards */}
                        <Grid
                            item
                            size={{ xs: 12, sm: 6, md: 3 }}


                        >
                            <Card
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    transition: 'transform 0.3s, box-shadow 0.3s',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                                    },
                                    cursor: "pointer",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                                onClick={BlackhandleClick}
                            >
                                {/* Card Image */}
                                <CardMedia
                                    component="img"
                                    height="200"
                                    image={cardDataa.tpm_image1}
                                    alt='image'
                                    sx={{

                                        width: '100%',
                                    }}
                                />

                                {/* Card Content */}
                                <CardContent sx={{
                                    flexGrow: 1, p: 2, '&:hover': {
                                        backgroundColor: "#e5e5e5"
                                    },
                                }}>
                                    <Typography
                                        gutterBottom
                                        variant="h6"
                                        component="div"
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: { xs: '16px', md: '18px' },
                                            fontFamily: 'Open Sans',
                                            color: '#333',
                                            mb: 1,
                                            textAlign: 'center'

                                        }}
                                    >
                                        {cardDataa.tpm_title1}
                                    </Typography>


                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid
                            item
                            size={{ xs: 12, sm: 6, md: 3 }}


                        >
                            <Card
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    transition: 'transform 0.3s, box-shadow 0.3s',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                                    },
                                    cursor: "pointer",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                                onClick={GreenhandleClick}
                            >
                                {/* Card Image */}
                                <CardMedia
                                    component="img"
                                    height="200"
                                    image={cardDataa.tpm_image2}
                                    alt='image'
                                    sx={{

                                        width: '100%',
                                    }}
                                />

                                {/* Card Content */}
                                <CardContent sx={{
                                    flexGrow: 1, p: 2, '&:hover': {
                                        backgroundColor: "#e5e5e5"
                                    },
                                }}>
                                    <Typography
                                        gutterBottom
                                        variant="h6"
                                        component="div"
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: { xs: '16px', md: '18px' },
                                            fontFamily: 'Open Sans',
                                            color: '#333',
                                            mb: 1,
                                            textAlign: 'center'

                                        }}
                                    >
                                        {cardDataa.tpm_title2}
                                    </Typography>


                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                </Box>
            </Container>
        </>
    );
};

export default ProcessingCard;
